<template>
  <form :id="widgetType" @submit.prevent="addNewWidget">

    <CommunInputs :widgetConfig="widgetConfig">

    </CommunInputs>

  
    <label class="form-label">Icono</label>

    <IconsForm :value="widgetConfig"></IconsForm>

    <label class="form-label">Seleccionar color</label>
    <select
      v-model="widgetConfig.class"
      class="form-select"
      style="width: 100%"
    >
      <option class="text-success" value="success" label="Verde"></option>
      <option class="text-primary" value="primary" label="Azul"></option>
      <option class="text-warning" value="warning" label="Amarillo"></option>
      <option class="text-danger" value="danger" label="Rojo"></option>
    </select>

  </form>
</template>

<script>
import IconsForm from './IconsForm.vue';
import CommunInputs from './common/CommunInputs.vue';
export default {
  props: ["widgetConfig","addNewWidget","widgetType"],
  components:{
    IconsForm,
    CommunInputs
  }

}
</script>
